export default __webpack_public_path__ + "static/media/logo.7733d3ed.png";